const expireDateUnmask = (date: string) => {
  return `${date[3]}${date[4]}${date[0]}${date[1]}`;
};

export default expireDateUnmask;
